/**
 * @author Code Lai（赖传峰）
 * @email codelai@staritgp.com
 * @date 2017/11/9 10:37
 * @desc
 */
import Layout from './Layout'
import 'antd/dist/antd.css'

export default Layout
